import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  active: {
    color: theme.palette.success.main
  },
  base: {
    fontWeight: "bold",
    textTransform: "uppercase"
  },
  inactive: {
    color: theme.palette.error.main
  },
  expired: {
    color: theme.palette.grey[600]
  }
}));

export default function SubscriptionStatus({ status }) {
  const classes = useStyles();
  return (
    <span>
      <span
        className={clsx(classes.base, {
          [classes.expired]: status === "expired",
          [classes.active]: status === "active",
          [classes.inactive]: status === "inactive"
        })}
      >
        {status}
      </span>
    </span>
  );
}
